import React, {Component} from 'react';
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
/*ui*/
import {withStyles} from '@material-ui/core/styles';
/*components*/
import getURLParameters from "../../helpers/getURLParameters";
import _get from "lodash/get";
import qs from 'qs'
import SectionBox from "../../components/SectionBox";
import CarListingFaraRabla from "./Listing";
import {fetchPage} from "../../actions/pages";
import {setCurrentActiveDealer} from "../../actions/dealer";
import {PAGES_SLUGS} from "../../constants";
import _isEmpty from "lodash/isEmpty";
import Seo from "../../components/seo/Seo";

const styles = theme => ({
    // ...defaultStyles(theme),
    productCard: {
        padding: 12,
        [theme.breakpoints.down('xs')]: {
            padding: 8
        }
    },
});

class CarsFaraRabla extends Component {
    state = {
        queryString: ''
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        const currentQueryString = _get(getURLParameters(), 'query', '');
        if (currentQueryString) {
            this.updateState(currentQueryString);
        }

        if (_isEmpty(this.props.pageData)) {
            this.props.fetchPage(PAGES_SLUGS.PRODUCTS)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const currentQueryString = _get(getURLParameters(), 'query', '');
        if (prevState.queryString !== currentQueryString) {
            this.updateState(currentQueryString);
        }
    }

    updateState = (query) => {
        this.setState({
            queryString: query
        })
    };

    render() {
        const pageContent = _get(this.props.pageData, 'data.ro', {});
        return (
            <React.Fragment>
                {!_isEmpty(pageContent) &&
                <Seo data={pageContent}/>}
                <SectionBox gutterTop={false}>
                    <CarListingFaraRabla
                        isDealerPage={!!this.props.isDealerPage}
                        defaultQuery={this.state.queryString}
                    />
                </SectionBox>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        pageData: _get(state.pages.data, PAGES_SLUGS.PRODUCTS, {}),
        loading: state.pages.request,
        error: state.pages.error,
        location: state.router.location,
        isDealerPage: state.dealer.data,
    }
}

CarsFaraRabla = withRouter(CarsFaraRabla);
CarsFaraRabla = withStyles(styles)(CarsFaraRabla);
CarsFaraRabla = connect(mapStateToProps, {fetchPage, setCurrentActiveDealer})(CarsFaraRabla);
export default CarsFaraRabla;
